import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgLockOpen({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2a6 6 0 015.996 5.775L18 8v1.171c1.166.412 2 1.523 2 2.829v7a3 3 0 01-3 3H7a3 3 0 01-3-3v-7a3 3 0 013-3h9V8a4 4 0 00-3.8-3.995L12 4a3.992 3.992 0 00-3.2 1.598 1 1 0 01-1.598-1.202A5.991 5.991 0 0112 2zm5 9H7a1 1 0 00-1 1v7a1 1 0 001 1h10a1 1 0 001-1v-7a1 1 0 00-1-1zm-5 2.5a2 2 0 110 4 2 2 0 010-4z"
        fill={color}
      />
    </svg>
  )
}

export default SvgLockOpen
